/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { globalBreak } from '@/styles/break';
import { SxProps, Theme } from '@mui/material';

export const productCardContentSX: SxProps<Theme> = (theme: Theme) => ({
	py: 0,
	flex: '1',
	marginBottom: theme.breakpoints.up('sm')?theme.spacing(0):0,
	px:globalBreak({mobile:0,desktop:0}),
	pb:0,
	'&:last-child':{
		pb:0
	}
});